module.exports = __webpack_public_path__ + "img/logo-ur.7e6cb7c3.png";